export const API_URL = import.meta.env.REACT_APP_API_URL || 'http://localhost:3310';
export const AUTH_URL = import.meta.env.REACT_APP_AUTH_URL || 'http://localhost:3311';
export const AUTHORIZED_USER_INITIAL_STATE = 'base-layout.users';
